import React from 'react';
import { AlyzeLogoA } from '@shared/components/icons';
import { 
  FooterSectionHeader, 
  FooterLink, 
  SocialIconLink,
  TikTokIcon,
  YouTubeIcon,
  InstagramIcon,
  FacebookIcon
} from './components';

export const FooterTop: React.FC = () => {
  return (
    <div className="flex flex-col md:flex-row md:h-[280px] md:justify-between items-start gap-8 md:gap-0">
      {/* Logo */}
      <div className="w-[140px] h-[140px] md:w-[280px] md:h-[280px] flex-shrink-0">
        <AlyzeLogoA color="#444444" className="w-full h-full" />
      </div>

      {/* Explore Section */}
      <div className="w-full md:w-[300px] flex flex-col">
        <FooterSectionHeader>EXPLORE</FooterSectionHeader>
        <div className="flex flex-col">
          <FooterLink href="/alyze-membership-waitlist">Join the Waitlist</FooterLink>
          <FooterLink href="/#whole-solution">Services</FooterLink>
          <FooterLink href="https://alyzehealth.bamboohr.com/careers">Careers</FooterLink>
        </div>
      </div>

      {/* Company Section */}
      <div className="w-full md:w-[240px] md:h-[400px] flex flex-col">
        <FooterSectionHeader className="pb-0">COMPANY</FooterSectionHeader>
        <div className="self-stretch flex flex-col">
          <div className="self-stretch pt-[8px] pb-[16px] flex items-center">
            <a 
              href="mailto:support@alyze.health" 
              className="!text-white text-base font-medium leading-[22.4px] underline hover:text-[#C3B89F] transition-colors font-['Figtree']"
            >
              support@alyze.health
            </a>
          </div>
          <div className="self-stretch pt-[8px] flex items-center">
            <div className="text-white text-base font-medium leading-[22.4px] font-['Figtree']">
              155 W 500 S #3<br />
              Bountiful, UT 84010
            </div>
          </div>
        </div>

        {/* Spacer with divider line */}
        <div className="self-stretch pt-[20px] pb-[20px] flex flex-col gap-2.5">
          <div className="w-full h-[1px] bg-[#666666]" style={{ backgroundColor: '#666666', height: '1px' }} />
        </div>

        {/* Follow Us Section */}
        <FooterSectionHeader className="pb-0">FOLLOW US</FooterSectionHeader>
        <div className="pt-[12px] pb-4 md:pb-[12px] flex items-center gap-[26px]">
          <SocialIconLink 
            href="https://www.youtube.com/@alyze.health"
            label="YouTube"
            icon={<YouTubeIcon />}
          />
          <SocialIconLink 
            href="https://www.facebook.com/p/ALYZE-Health-61583241363324/"
            label="Facebook"
            icon={<FacebookIcon />}
          />
          <SocialIconLink 
            href="https://www.tiktok.com/@alyze.health"
            label="TikTok"
            icon={<TikTokIcon />}
          />
          <SocialIconLink 
            href="https://www.instagram.com/alyzehealth/"
            label="Instagram"
            icon={<InstagramIcon />}
          />
        </div>
      </div>
    </div>
  );
};
